import { Component, Event, EventEmitter, Prop, State, h } from '@stencil/core';

@Component({
  tag: 'biel-terms-modal',
  styleUrl: 'biel-terms-modal.css',
  shadow: true,
})
export class BielTermsModal {
  @Prop() termsTitle: string = 'Chatbot Terms & Conditions';
  @Prop() termsDescription: string =
    "Please review our <a href='https://biel.ai/terms' target='_blank' rel='noopener'>Terms & Conditions</a> before proceeding.";
  @Prop() termsCheckboxText: string = 'I have read and agree to the Terms & Conditions.';

  @Event() termsAccepted: EventEmitter<void>;
  @Event() termsDeclined: EventEmitter<boolean>;

  @State() isChecked: boolean = false;

  handleCheckboxChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    this.isChecked = checkbox.checked;
  }

  handleAccept() {
    this.termsAccepted.emit();
  }

  handleDecline() {
    this.termsDeclined.emit(true);
  }

  render() {
    return (
      <div class="biel-terms-modal" part="overlay">
        <div class="biel-terms-modal-content" part="modal">
          <div class="biel-terms-modal-header">
            <h2 class="biel-terms-modal-title" part="title">
              {this.termsTitle}
            </h2>
            <button
              class="close-btn"
              part="close-button"
              onClick={() => this.handleDecline()}
              aria-label="Close"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-x"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>
          </div>
          <p class="biel-terms-modal-text" part="description" innerHTML={this.termsDescription}></p>
          <div class="checkbox-container" part="checkbox-container">
            <input
              type="checkbox"
              id="accept-terms"
              onInput={(event) => this.handleCheckboxChange(event)}
            />
            <label htmlFor="accept-terms">{this.termsCheckboxText}</label>
          </div>
          <div class="button-container" part="button-container">
            <button
              class="btn decline-btn"
              part="decline-button"
              onClick={() => this.handleDecline()}
            >
              Decline
            </button>
            <button
              class="btn accept-btn"
              part="accept-button"
              onClick={() => this.handleAccept()}
              disabled={!this.isChecked}
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    );
  }
}
